var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1716",
    d: "M0-682.665H70v70H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43436",
    "data-name": "Group 43436",
    transform: "translate(-5178 -19889)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16107",
    "data-name": "Rectangle 16107",
    width: 80,
    height: 80,
    transform: "translate(5178 19889)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "left-and-right-arrows",
    transform: "translate(5183 19894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1714",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1720",
    transform: "translate(45.254 33.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1722",
    d: "M0,0,16.406,16.406,0,32.813",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "square",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1724",
    transform: "translate(2.734 49.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1726",
    d: "M-494.2,0h-56.465",
    transform: "translate(550.665)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1728",
    transform: "translate(8.477 3.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1730",
    d: "M-143.593,0-160,16.406l16.406,16.406",
    transform: "translate(160)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "square",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1732",
    transform: "translate(10.938 20.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1734",
    d: "M0,0H56.328",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 6
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.6ea0b2811c1f18f0a7ada796a9889899.svg";
export { ForwardRef as ReactComponent };